import React from 'react';

import { correctingTrailingNumbers } from '@cryptoboyio/mercuryo-lab/utils';

import { bemCssModules, getStatus, getTestId } from '@utils';
import { useLocation, useNavigate } from '@utils/hooks';
import { LocationStateType } from '@utils/types';

import { useStore } from '@modules';

import VerifyCard from '@containers/VerifyCard';
import MainLayout from '@layouts/MainLayout';

import style from './TopupVerifyCard.scss';

const cn = bemCssModules(style, 'TopupVerifyCard');
const ti = getTestId('TopupVerifyCard');

export const TopupVerifyCard: CustomFC = ({ className }) => {
  const [{ cards, buy, global }] = useStore();
  const navigate = useNavigate();
  const { bindStatus } = cards;
  const { buyStatus } = buy;
  const { config } = global.currencies;
  const location = useLocation<LocationStateType['verifyCard']>();
  const { state } = location;
  const { currency, amount } = state;

  const displayAmount = amount
    ? correctingTrailingNumbers(
        amount,
        config.display_options?.[currency]?.display_digits,
        config.display_options?.[currency]?.total_digits
      )
    : '';
  const totalWithCurrency = displayAmount ? `${displayAmount} ${currency}` : currency;

  const onBack = () => navigate<'wallets'>(CONST.nav.wallets, { state: { cacheConverter: true } });
  const { isFailed, isSucceeded } = getStatus(buyStatus);

  const onSuccess = () => {
    const statusIsSucceeded = bindStatus === CONST.card3DS.statuses.succeeded;
    const statusIsFailed = bindStatus === CONST.card3DS.statuses.failed;

    const walletsState = {
      cacheConverter: true,
      buySuccessNotification: isSucceeded && totalWithCurrency,
      buyErrorNotification: isFailed,
      bindCarsSuccessNotification: statusIsSucceeded,
      bindCardFailedNotification: statusIsFailed,
    };

    navigate<'wallets'>(CONST.nav.wallets, { state: walletsState });
  };

  return (
    <MainLayout className={cn(null, [className])} data-testid={ti()} backButton={onBack}>
      <VerifyCard onSuccessFlow={onSuccess} />
    </MainLayout>
  );
};

export default TopupVerifyCard;
